<template>
  <div>
    <scenario-item-text class="pa-3" :title="title" :description="description"></scenario-item-text>
    <scenario-item-buttons v-if="buttons" :brandKey="brandKey" :chatRoomId="chatRoomId" :buttons="buttons" :preview="preview"></scenario-item-buttons>
  </div>
</template>

<script>
import scenarioItemText from '../item/scenario_item_text'
import scenarioItemButtons from '../item/scenario_item_buttons'

export default {
  name: 'scenario_template_text',
  components: {
    scenarioItemText, scenarioItemButtons
  },
  props: [
    'brandKey', 'chatRoomId', 'title', 'description', 'buttons', 'preview'
  ]
}
</script>



// WEBPACK FOOTER //
// src/components/webchat/message/fragments/scenario/templates/scenario_template_text.vue